import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import TaxTable from '@accounting/components/tables/tax-table/tax-table.vue';

@Component({
  name: 'bpc-taxes',
  components: {
    'bpc-tax-table': TaxTable,
  },
})
export default class Taxes extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
